import {
    SET_CAT, SET_FNAME, SET_MNAME, SET_GENDER, SET_DISABILITIES, SET_WPNO,
    SET_STATE, SET_USER, SET_CUSTOMERID, SET_DIST, SET_BLOCK, SET_VILLAGE,
    SET_PIN, SET_TEN_SCL, SET_TEN_SCL_BOARD, SET_TEN_SCL_PASS, SET_TEN_SCL_FULLMARK,
    SET_TEN_SCL_FULLMARK_SEC, SET_CLG, SET_CLG_BOARD, SET_CLG_PASS, SET_CLG_FULLMARK,
    SET_CLG_FULLMARK_SEC, SET_CLG_NEET, SET_CLG_NEETATM, SET_CITY_CENTER, SET_STUDY_CENTER,
    SET_PROFILE_PIC, SET_USER_DATA, SET_PER, SET_HOSTEL, SET_MEDIUM, SET_TYPE, SET_EMAIL
} from "./constant";
import UNIVERSAL from "../../config/config";
import { setLoader, unsetLoader } from "../../common/loader/action";
import { set_snack_bar } from "../../common/snackbar/action";

// ============================================================
// ImageKit Upload Utility
// Replace these with your ImageKit credentials
// ============================================================
const IMAGEKIT_PUBLIC_KEY = "public_L1bTWOngT+rd7wPdVLMLC/txUMw=";
const IMAGEKIT_PRIVATE_KEY = "private_2WmGWdRsWvKYjU+QO5z+WVFACB4=";
const IMAGEKIT_URL_ENDPOINT = "https://ik.imagekit.io/xluyh5sad";

/**
 * Upload a file to ImageKit and return the public URL.
 * Uses the ImageKit Upload API (no SDK needed — plain fetch).
 * Supports both image and PDF files.
 */
async function uploadToImageKit(file, fileName, folder = "neet2027") {
    // Get upload auth params from ImageKit
    const authResponse = await fetch(`${UNIVERSAL.BASEURL}imagekit_auth`, {
        method: "GET",
        headers: { Accept: "application/json" }
    });
    const auth = await authResponse.json();

    const formData = new FormData();
    formData.append("file", file);
    formData.append("fileName", fileName);
    formData.append("folder", folder);
    formData.append("publicKey", IMAGEKIT_PUBLIC_KEY);
    formData.append("signature", auth.signature);
    formData.append("expire", auth.expire);
    formData.append("token", auth.token);

    const uploadResponse = await fetch("https://upload.imagekit.io/api/v1/files/upload", {
        method: "POST",
        body: formData
    });
    const uploadResult = await uploadResponse.json();
    if (uploadResult.url) return uploadResult.url;
    throw new Error(`ImageKit upload failed: ${JSON.stringify(uploadResult)}`);
}

// ============================================================
// addUploadAsset — uploads files to ImageKit then saves to DB
// ============================================================
export function addUploadAsset(
    id, aplicantname, mobile, aadhar, dob, gender, category, fname, mname, disabilities, wpno,
    state, dist, block, village, pin, tenth, tenboard, tenyrpassing, tenfullmark, tenfullmarksecured,
    twoth, twoboard, twoyrpassing, twofullmark, twofullmarksecured, neet, neetatm, exmacenter,
    profile_pic, profile_picprev, aadhar_pic, aadhar_picprev, ten_pic, ten_picprev
) {
    return async (dispatch) => {
        dispatch(setLoader());
        try {
            let profile_pic_url = profile_picprev || "";
            let aadharcertif_url = aadhar_picprev || "";
            let ten_pic_url = ten_picprev || "";

            // Upload passport photo to ImageKit (if new file selected)
            if (profile_pic) {
                profile_pic_url = await uploadToImageKit(
                    profile_pic,
                    `passport_${aplicantname}_${Date.now()}.jpg`,
                    "neet2027/passport"
                );
            }

            // Upload Aadhaar card to ImageKit (if new file selected)
            if (aadhar_pic) {
                aadharcertif_url = await uploadToImageKit(
                    aadhar_pic,
                    `aadhar_${aplicantname}_${Date.now()}.${aadhar_pic.name.split('.').pop()}`,
                    "neet2027/aadhar"
                );
            }

            // Upload 10th marksheet / sign to ImageKit (if new file selected)
            if (ten_pic) {
                ten_pic_url = await uploadToImageKit(
                    ten_pic,
                    `sign_${aplicantname}_${Date.now()}.${ten_pic.name.split('.').pop()}`,
                    "neet2027/sign"
                );
            }

            dispatch(addAsset(
                id, aplicantname, mobile, aadhar, dob, gender, category, fname, mname, disabilities, wpno,
                state, dist, block, village, pin, tenth, tenboard, tenyrpassing, tenfullmark, tenfullmarksecured,
                twoth, twoboard, twoyrpassing, twofullmark, twofullmarksecured, neet, neetatm, exmacenter,
                profile_pic_url, aadharcertif_url, ten_pic_url
            ));
        } catch (error) {
            console.error("ImageKit upload error:", error);
            dispatch(set_snack_bar(false, "File upload failed. Please try again."));
            dispatch(unsetLoader());
        }
    };
}

// ============================================================
// addAsset — saves user data to MongoDB via backend API
// ============================================================
export function addAsset(
    id, aplicantname, mobile, aadhar, dob, gender, category, fname, mname, disabilities, wpno,
    state, dist, block, village, pin, tenth, tenboard, tenyrpassing, tenfullmark, tenfullmarksecured,
    twoth, twoboard, twoyrpassing, twofullmark, twofullmarksecured, neet, neetatm, exmacenter,
    profile_pic_url, aadharcertif_url, ten_pic_url
) {
    return (dispatch) => {
        dispatch(setLoader());
        return fetch(UNIVERSAL.BASEURL + "update_user", {
            method: "POST",
            headers: { Accept: "application/json", "Content-Type": "application/json" },
            body: JSON.stringify({
                id, name: aplicantname, mobile, aadhar, dob, gender, category, fname, mname,
                disabilities, wpno, state, dist, block, village, pin, tenth, tenboard, tenfullmark,
                tenfullmarksecured, tenyrpassing, twoth, twoboard, twofullmark, twofullmarksecured,
                twoyrpassing, neet, neetatm,
                aadharcertif: aadharcertif_url,
                tenthmarksheet: ten_pic_url,
                profile_pic: profile_pic_url,
                exmacenter,
            })
        })
            .then(res => res.json())
            .then(responseJson => {
                if (responseJson.status) {
                    dispatch(set_snack_bar(true, responseJson.message));
                } else {
                    dispatch(set_snack_bar(false, responseJson.message || "Update failed"));
                }
                dispatch(unsetLoader());
            })
            .catch(error => {
                dispatch(unsetLoader());
                dispatch(set_snack_bar(false, "Network error. Check your connection."));
                console.error(error);
            });
    };
}

// ============================================================
// Userdetails — fetch user data by ID
// ============================================================
export function Userdetails(id) {
    return async (dispatch) => {
        dispatch(setLoader());
        return fetch(UNIVERSAL.BASEURL + "view_user_by_id", {
            method: "POST",
            headers: { Accept: "application/json", "Content-Type": "application/json" },
            body: JSON.stringify({ user_id: id })
        })
            .then(res => res.json())
            .then(responseJson => {
                if (responseJson.status) {
                    const r = responseJson.result;
                    dispatch(setCustomerid(r._id));
                    dispatch(SetprofileCat(r.category));
                    dispatch(setFname(r.fname));
                    dispatch(setMname(r.mname));
                    dispatch(setGender(r.gender));
                    dispatch(serDisabilities(r.disabilities));
                    dispatch(setWp(r.wpno));
                    dispatch(setSaste(r.state));
                    dispatch(setDist(r.dist));
                    dispatch(setBlock(r.block));
                    dispatch(setvillage(r.village));
                    dispatch(setPin(r.pin));
                    dispatch(setTenScl(r.tenth));
                    dispatch(setTenSclBord(r.tenboard));
                    dispatch(setTenSclpass(r.tenyrpassing));
                    dispatch(setTenSclfullmark(r.tenfullmark));
                    dispatch(setTenSclfullmarksec(r.tenfullmarksecured));
                    dispatch(setTowClg(r.twoth));
                    dispatch(setTowClgBord(r.twoboard));
                    dispatch(setTowClgpass(r.twoyrpassing));
                    dispatch(setTowClgfullmark(r.twofullmark));
                    dispatch(setTowClgfullmarksec(r.twofullmarksecured));
                    dispatch(setNeet(r.neet));
                    dispatch(setNeetatm(r.neetatm));
                    dispatch(setCitycenter(r.exmacenter));
                    dispatch(setStudycenter(r.studycenter));
                    dispatch(setprofile_pic(r.profile_pic));
                    dispatch(setUserData(r));
                    dispatch(setper(r.per));
                    dispatch(setmedium(r.medium));
                    dispatch(setSclType(r.schooltype));
                    dispatch(sethostel(r.hostel));
                    dispatch(setEmail(r.email));
                    dispatch({ type: SET_USER, payload: { data: r, count: r } });
                    dispatch(set_snack_bar(true, responseJson.message));
                } else {
                    dispatch({ type: SET_USER, payload: { data: [], count: 0 } });
                    dispatch(set_snack_bar(false, responseJson.message));
                }
                dispatch(unsetLoader());
            })
            .catch(error => {
                console.error(error);
                dispatch(unsetLoader());
            });
    };
}

// ============================================================
// Simple setter actions
// ============================================================
export const setCustomerid = (payload) => ({ type: SET_CUSTOMERID, payload });
export const SetprofileCat = (payload) => ({ type: SET_CAT, payload });
export const setFname = (payload) => ({ type: SET_FNAME, payload });
export const setMname = (payload) => ({ type: SET_MNAME, payload });
export const setGender = (payload) => ({ type: SET_GENDER, payload });
export const serDisabilities = (payload) => ({ type: SET_DISABILITIES, payload });
export const setWp = (payload) => ({ type: SET_WPNO, payload });
export const setSaste = (payload) => ({ type: SET_STATE, payload });
export const setDist = (payload) => ({ type: SET_DIST, payload });
export const setBlock = (payload) => ({ type: SET_BLOCK, payload });
export const setvillage = (payload) => ({ type: SET_VILLAGE, payload });
export const setPin = (payload) => ({ type: SET_PIN, payload });
export const setTenScl = (payload) => ({ type: SET_TEN_SCL, payload });
export const setTenSclBord = (payload) => ({ type: SET_TEN_SCL_BOARD, payload });
export const setTenSclpass = (payload) => ({ type: SET_TEN_SCL_PASS, payload });
export const setTenSclfullmark = (payload) => ({ type: SET_TEN_SCL_FULLMARK, payload });
export const setTenSclfullmarksec = (payload) => ({ type: SET_TEN_SCL_FULLMARK_SEC, payload });
export const setper = (payload) => ({ type: SET_PER, payload });
export const setTowClg = (payload) => ({ type: SET_CLG, payload });
export const sethostel = (payload) => ({ type: SET_HOSTEL, payload });
export const setTowClgBord = (payload) => ({ type: SET_CLG_BOARD, payload });
export const setTowClgpass = (payload) => ({ type: SET_CLG_PASS, payload });
export const setTowClgfullmark = (payload) => ({ type: SET_CLG_FULLMARK, payload });
export const setTowClgfullmarksec = (payload) => ({ type: SET_CLG_FULLMARK_SEC, payload });
export const setNeet = (payload) => ({ type: SET_CLG_NEET, payload });
export const setNeetatm = (payload) => ({ type: SET_CLG_NEETATM, payload });
export const setCitycenter = (payload) => ({ type: SET_CITY_CENTER, payload });
export const setStudycenter = (payload) => ({ type: SET_STUDY_CENTER, payload });
export const setprofile_pic = (payload) => ({ type: SET_PROFILE_PIC, payload });
export const setUserData = (payload) => ({ type: SET_USER_DATA, payload });
export const setmedium = (payload) => ({ type: SET_MEDIUM, payload });
export const setSclType = (payload) => ({ type: SET_TYPE, payload });
export const setEmail = (payload) => ({ type: SET_EMAIL, payload });
